import { render, staticRenderFns } from "./provisioning.vue?vue&type=template&id=06422822"
import script from "./provisioning.vue?vue&type=script&lang=js"
export * from "./provisioning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports